// extracted by css-extract-rspack-plugin
export default {"root":"root-MpvtNh","stackWhenCompact":"stackWhenCompact-xwfL4T","text":"text-ba2MTH text-headline-lg"};